import {
  createRouter,
  type RouteIds,
  RouteById as GenericRouteById,
  type NavigateOptions,
} from '@tanstack/react-router';
import { type FileRoutesById, routeTree } from './routeTree.gen';

const NotFoundPage = () => {
  return (
    <section style={{ textAlign: 'center', paddingTop: 100 }}>
      <h1>404 - Page Not Found</h1>
      <p>The page you requested could not be found.</p>
      <p>Current URL: {router.state.location.pathname}</p>
      <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center', gap: 8 }}>
        <button
          style={{ cursor: 'pointer', padding: '8px 16px', border: 'none', borderRadius: '4px', background: 'white' }}
          onClick={() => router.history.back()}
        >
          Go Back
        </button>
        <button
          style={{
            cursor: 'pointer',
            padding: '8px 16px',
            border: 'none',
            borderRadius: '4px',
            background: '146EF5',
            color: 'white',
          }}
          onClick={() => router.navigate({ to: '/' })}
        >
          Go to Home
        </button>
      </div>
    </section>
  );
};

export const router = createRouter({
  defaultNotFoundComponent: NotFoundPage,
  routeTree,
  defaultPreload: 'intent',
  context: {
    authenticated: false,
    user: undefined,
    lastLocationId: undefined,
  },
});

export type RouterType = typeof router;
export type RouterIds = RouteIds<RouterType['routeTree']>;
export type RouteById<T extends RouterIds> = GenericRouteById<RouterType['routeTree'], T>;
export type Navigation = NavigateOptions<RouterType>;
export type { FileRoutesById };
